'use strict';
const mmWidgets = require('./mm-widgets');

mmWidgets.fn.splittableWidget = function (splittableController, mapModel, keepOpenOnReset) {
	const sidebarAttr = 'sidebar',
		sidebarSizeAttr = 'sidebar-size',
		KEY_TAB = 9,
		KEY_ESC = 27,
		mine = function (e) {
			e.preventDefault();
			e.stopImmediatePropagation();
			e.stopPropagation();
		};
	if (!keepOpenOnReset) {
		mapModel.addEventListener('mapViewResetRequested', function () {
			splittableController.hide();
		});
	}
	return mmWidgets.each(this, function () {
		const element = this;
		splittableController.addEventListener('hide', function () {
			element.removeAttr(sidebarAttr).removeAttr(sidebarSizeAttr);
			mapModel.centerOnNode(mapModel.getSelectedNodeId());
			element.find('[data-mm-role~="primary"]').focus();
		});
		splittableController.addEventListener('show', function (sidebar, sidebarSize) {
			if (sidebarSize) {
				element.attr(sidebarSizeAttr, sidebarSize);
			} else {
				element.removeAttr(sidebarSizeAttr);
			}
			element.attr(sidebarAttr, sidebar);
			mapModel.centerOnNode(mapModel.getSelectedNodeId());

		});
		element.find('sidebar').on('keydown', function (e) {
			if (e.which === KEY_TAB || e.which === KEY_ESC) {
				element.find('[data-mm-role~="primary"]').focus();
				mine(e);
			}
		});

	});
};
